export enum SidebarRoutesEnum {
  MODIFIERS = "Modifiers",
  EVENTS = "Events",
  CUSTOMERS = "Customers",
}